export default ($) => {

	if($('body').hasClass('page-hot-tub-dealers')) {

		window.hashName = window.location.hash;
		$(window).load(function () {
			if($(window.hashName).length) {
				$('html, body').animate({scrollTop: $(window.hashName).offset().top-96}, 0);

				return false;
			}
		});
	}

}
